/**
  * @class msysAbstractService
  * @description
  * Implements base structure of service.
  * Not intended for direct use. Used by msys*Service modules as base class.
  */

import msysListener from 'msysListener'

export default class msysAbstractService extends msysListener {
} // msysAbstractService
